enum VendorSubscriptionStatus {
  EmailNotSent = 'EmailNotSent',
  EmailSent = 'EmailSent',
  Accepted = 'Accepted',
  Declined = 'Declined',
  Unsubscribed = 'Unsubscribed',
}

export default VendorSubscriptionStatus;
